import React, { useEffect } from 'react';
import { head, isNil } from 'ramda';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@material-ui/core';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';

import useStyles from './useStyles';

const SelectQuestion = props => {
  const { question, onChange, values, setValidity } = props;
  const classes = useStyles();
  const field = head(QuizQuestionPresenter.quizFields(question));
  const currentValue = QuizPresenter[field](values);

  useEffect(() => {
    const isValid = !isNil(currentValue);

    setValidity(isValid);
  }, [currentValue]);

  const handleSelectValue = value => () => {
    const fieldValues = QuizPresenter.prepareFieldValues(field, value);
    fieldValues.forEach(onChange);
  };

  const options = QuizQuestionPresenter.options(question);

  return (
    <Box>
      <Typography variant="h1">{QuizQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{QuizQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <Box display="flex" width="100%" my={3} flexWrap="wrap">
        {options.map(({ label, value }) => {
          const isSelected = currentValue === value;
          return (
            <Button
              key={label}
              onClick={handleSelectValue(value)}
              className={clsx(classes.button, { [classes.selected]: isSelected })}
            >
              {label}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

SelectQuestion.propTypes = {
  question: QuizQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  values: QuizPresenter.shape().isRequired,
};

export default SelectQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SelectQuestion/SelectQuestion.js